import { createContext, useState } from "react";

const RoomContext = createContext(null);
export const RoomProvider = ({ children }) => {
  const [State, setState] = useState({
    RoomId: "",
    RoomCustomers: [],
    RoomUsers: [],
    RoomName: "",
  });
  const OnChange = (Name, Value) => {
    if (typeof Name == "object") {
      setState(Name);
      return;
    }
    setState((prev) => ({
      ...prev,
      [Name]: Value,
    }));
  };
  const OnReset = () => {
    setState({
      RoomId: "",
      RoomCustomers: [],
      RoomUsers: [],
      RoomName: "",
    });
  };

  return (
    <RoomContext.Provider value={{ State, OnChange, OnReset }}>
      {children}
    </RoomContext.Provider>
  );
};

export default RoomContext;
